import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { API_URL } from "@equine-ui-nx/injection-tokens";
import { Observable } from "rxjs";
import { IBtCreditCard, IBtUsBankAccount } from "../interfaces/braintree.interfaces";

@Injectable({
  providedIn: 'root'
})
export class BraintreeService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);
  // private apiUrl = 'http://localhost:8080/api';


  getBraintreeTokenAndCustomerData(userId: string): Observable<{clientToken: string, userId: string, btCustomer: {id?: string, creditCards?: IBtCreditCard[], usBankAccounts?: IBtUsBankAccount[]}}> {
    return this.http.post<{clientToken: string, userId: string, btCustomer: {creditCards?: IBtCreditCard[], usBankAccounts?: IBtUsBankAccount[]}}>(`${this.apiUrl}/payments/getOrCreateBraintreeCustomerTokenByUserId`, {userId})
  }

  vaultBankAccount(userId: string, nonce: string) {
    return this.http.post<any>(`${this.apiUrl}/payments/vaultBankAccount`, {userId, nonce});
  }

  removeBtPaymentMethod(token: string) {
    return this.http.post<any>(`${this.apiUrl}/payments/removeBtPaymentMethod`, {token});
  }

  verifyAccount(verificationId: string, deposits: number[]) {
    return this.http.post<any>(`${this.apiUrl}/payments/verifyAccountWithMicroDeposits`, {verificationId, deposits});
  }

  checkPendingBraintreeVerifications(userId: string): Observable<{pending: boolean}> {
    return this.http.post<{pending: boolean}>(`${this.apiUrl}/payments/hasPendingBrainteeAccountVerification`, {userId});
  }

  getBraintreePaymentOptionsPayloadForPaypal(reference: string): Observable<{amount: string, payload: any}> {
    return this.http.post<{amount: string, payload: any}>(`${this.apiUrl}/payments/getBraintreePaymentOptions`, {
      cartReference: reference,
      type: 'PAYPAL_CAPTURE'
    });
  }

  captureWithBTAch(cartId: string, token: string, deviceData: string) {
    return this.http.post<any>(`${this.apiUrl}/payments/createBraintreeTransaction`,
      {cartId, paymentMethodNonceOrToken: token, nonceOrToken: 'TOKEN', deviceData});
  }

  payWithPaypal(cartId: string, nonce: string, deviceData: string): Observable<{clientToken: string} > {
    return this.http.post<{clientToken: string}>(`${this.apiUrl}/payments/createBraintreeTransaction`,
      {cartId, paymentMethodNonceOrToken: nonce, nonceOrToken: 'NONCE', deviceData})
  }

  payWithCreditCardNonce(cartId: string, nonce: string, deviceData: string, vaultCard: boolean): Observable<{clientToken: string} > {
    return this.http.post<{clientToken: string}>(`${this.apiUrl}/payments/createBraintreeTransaction`,
      {cartId, paymentMethodNonceOrToken: nonce, nonceOrToken: 'NONCE', deviceData, storeInVaultOnSuccess: vaultCard})
  }

  payWithSavedCreditCard(cartId: string, token: string, deviceData: string) {
    return this.http.post<any>(`${this.apiUrl}/payments/createBraintreeTransaction`,
      {cartId, paymentMethodNonceOrToken: token, nonceOrToken: 'TOKEN', deviceData});
  }


}